import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, Text, useTheme } from '@ublend-npm/aulaui-core';
import { EDUCATOR_ROLE } from '@core/constants/space';
import { HOME_VIEW_ROLE_LABELS } from '@app/constants/home';
import { getHomeSpacesForView, getHomeViewRole } from '@app/selectors/home';

const HomeSpacesSection = () => {
  const { palette } = useTheme();
  const viewRole = useSelector(getHomeViewRole);
  const spaces = useSelector(getHomeSpacesForView);
  const roleLabel = HOME_VIEW_ROLE_LABELS[viewRole];

  if (spaces.length === 0) {
    return (
      <Card
        sx={{
          borderRadius: '0.75rem',
          padding: '2rem',
          boxShadow: 'none',
          border: `1px solid ${palette.divider}`,
        }}
      >
        <Text color="text.secondary" textAlign="center">
          No spaces to show in {roleLabel.toLowerCase()} view.
        </Text>
      </Card>
    );
  }

  return (
    <Box
      display="flex"
      gap="1rem"
      sx={{
        overflowX: 'auto',
        py: 1,
        '&::-webkit-scrollbar': { height: 6 },
      }}
    >
      {spaces.slice(0, 3).map((space) => (
        <Card
          key={space.objectId}
          sx={{
            minWidth: '20rem',
            maxWidth: '20rem',
            flexShrink: 0,
            borderRadius: '0.75rem',
            padding: '1.25rem',
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            boxShadow: 'none',
            height: '200px',
          }}
        >
          <Text fontSize="1.125rem" fontWeight={600} mb={1}>
            {space.name}
          </Text>
          {viewRole === EDUCATOR_ROLE && (
            <Text fontSize="0.875rem" sx={{ opacity: 0.9 }}>
              {space.studentCount ?? 0} students
            </Text>
          )}
        </Card>
      ))}
    </Box>
  );
};

export default HomeSpacesSection;
